module.exports = __webpack_public_path__ + "static/media/logintitle.9ded2367.png";